<script>
	import { Router, Route } from "svelte-routing";
	import Index from "./view/Index.svelte";
	import Start from "./view/Start.svelte";
	import Acara from "./view/Acara.svelte";
	import Map from "./view/Map.svelte";
  
	export let url = "";
  </script>
    <Router url="{url}">
	<Route path="/" component="{Index}" />
	<Route path="/start" component="{Start}" />
	<Route path="/acara" component="{Acara}" />
	<Route path="/map" component="{Map}" />
  </Router>
